import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { EditProfileDialog } from "./EditProfileDialog";

export const ProfileOnboarding = () => {
  const { user } = useApp();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (user && !user.alias && sessionStorage.getItem(`hive_onb_${user.address}`) !== "1") setOpen(true);
    if (!user) setOpen(false);
  }, [user]);
  if (!user) return null;
  const close = (v) => { setOpen(v); if (!v) sessionStorage.setItem(`hive_onb_${user.address}`, "1"); };
  return (
    <EditProfileDialog open={open} onOpenChange={close} title="Create your HIVEVORA profile"
      intro="Pick a nickname, add a profile image, bio and links. You can chat right away and edit this any time from My profile."
      profile={{ address: user.address, nickname: "", bio: "", links: [], avatar_url: user.avatar_url }} />
  );
};
